import { compose, propEq, find } from 'ramda'

export const getTvodCountdownWarning = compose(
  option => option.value,
  find(propEq('key', 'PLAYER_TVOD_COUNTDOWN_WARNING_LABEL'))
)
